const Navigation = (props) => {
    return (
      <>
        <nav className="navbar container ">
          <h1 className="fw-bold text-light">{props.navheading}</h1>
          
  
          <div className="dropdown text-light d-flex justify-content-between">
          <div>
          <img src={props.navphoto} alt="" className="rounded-circle trem d-none d-lg-block"/>
          </div>
            <button className="btn btn-light border dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {props.navphoto1}
            </button>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href="#a">Index</a></li>
              <li><a  className="dropdown-item" href="#a">Profile</a></li>
              <li><a  className="dropdown-item" href="#a">Setting</a></li>
            </ul>
          </div>
  
          <div className="text-light">
            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
              <i className="fa-solid fa-bars text-light"></i>
            </button>
            <div className="offcanvas offcanvas-start bg-dark"  id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">OneUI Vue</h5>
                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>
              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3 text-light">
                  <li className="nav-item pt-3"><a href="#anch" className="fw-bold text-decoration-none text-light">{props.navitem1}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="fw-bold text-decoration-none text-light">{props.navitem2}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="fw-bold text-decoration-none text-light">{props.navitem3}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem4}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem5}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem6}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem7}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light fw-bold">{props.navitem8}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem9}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem10}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem11}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light fw-bold">{props.navitem12}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem13}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem14}</a></li>
                  <li className="nav-item pt-3"><a href="#anch" className="text-decoration-none text-light">{props.navitem15}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </>
    );
  }
  export default Navigation